import _implicitStylesheets from "./packageContentsViewer.css";
import _implicitScopedStylesheets from "./packageContentsViewer.scoped.css?scoped=true";
import _listingSearchInput from "listing/searchInput";
import _wdsButton from "wds/button";
import _axCard from "ax/card";
import _axIcon from "ax/icon";
import _wdsEmptyState from "wds/emptyState";
import _wdsListingCard from "wds/listingCard";
import _axImage from "ax/image";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h2 type-style="display-6" class="viewer-title${0}" data-testid="viewer-title"${2}>${"t1"}</h2>`;
const $fragment2 = parseFragment`<p class="screen-reader-only${0}" role="status" aria-live="polite" data-testid="loading-status"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<span type-style="body-2" class="rollup-tile-label${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<span class="skeleton-shape skeleton-rollup-count${0}" aria-hidden="true"${2}></span>`;
const $fragment5 = parseFragment`<span type-style="body-1" class="rollup-tile-count${0}"${2}>${"t1"}</span>`;
const $fragment6 = parseFragment`<h3 type-style="display-7" class="section-heading${0}"${2}>${"t1"}</h3>`;
const $fragment7 = parseFragment`<div class="skeleton-card-header${0}"${2}><span class="skeleton-shape skeleton-avatar${0}"${2}></span><div class="skeleton-card-header-text${0}"${2}><span class="skeleton-shape skeleton-line-title${0}"${2}></span><span class="skeleton-shape skeleton-line-subtitle${0}"${2}></span><div class="skeleton-stars${0}"${2}><span class="skeleton-shape skeleton-star${0}"${2}></span><span class="skeleton-shape skeleton-star${0}"${2}></span><span class="skeleton-shape skeleton-star${0}"${2}></span><span class="skeleton-shape skeleton-star${0}"${2}></span><span class="skeleton-shape skeleton-star${0}"${2}></span></div></div></div>`;
const $fragment8 = parseFragment`<div class="skeleton-card-body${0}"${2}><span class="skeleton-shape skeleton-line-description${0}"${2}></span><span class="skeleton-shape skeleton-line-description${0}"${2}></span><span class="skeleton-shape skeleton-line-description-short${0}"${2}></span><div class="skeleton-tags${0}"${2}><span class="skeleton-shape skeleton-tag${0}"${2}></span><span class="skeleton-shape skeleton-tag${0}"${2}></span></div></div>`;
const $fragment9 = parseFragment`<span class="skeleton-shape skeleton-row-logo${0}"${2}></span>`;
const $fragment10 = parseFragment`<div class="item-row-text${0}"${2}><span class="skeleton-shape skeleton-row-title${0}"${2}></span><span class="skeleton-shape skeleton-row-subtitle${0}"${2}></span></div>`;
const $fragment11 = parseFragment`<span class="skeleton-shape skeleton-row-badge${0}"${2}></span>`;
const $fragment12 = parseFragment`<p type-style="body-3" class="empty-content-message${0}" data-testid="empty-content-message"${2}>${"t1"}</p>`;
const $fragment13 = parseFragment`<h3 type-style="display-7" class="section-heading${0}"${2}>${"t1"}</h3>`;
const $fragment14 = parseFragment`<div class="item-row-text${0}"${2}><span type-style="body-2" class="item-row-title${0}"${2}>${"t2"}</span><span type-style="caption" class="item-row-subtitle${0}"${2}>${"t4"}</span></div>`;
const $fragment15 = parseFragment`<span class="tag-pill category-pill${0}"${2}>${"t1"}</span>`;
const $fragment16 = parseFragment`<div class="item-row-text${0}"${2}><span type-style="body-2" class="item-row-title${0}"${2}>${"t2"}</span><span type-style="caption" class="item-row-subtitle${0}"${2}>${"t4"}</span></div>`;
const $fragment17 = parseFragment`<span class="tag-pill category-pill${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "viewer": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "controls-row": true
  },
  key: 5
};
const stc2 = {
  "search-bar": true
};
const stc3 = {
  classMap: {
    "display-toggle": true
  },
  key: 7
};
const stc4 = {
  "data-testid": "display-toggle-button"
};
const stc5 = {
  classMap: {
    "rollup-tiles": true
  },
  key: 9
};
const stc6 = {
  "rollup-tile": true
};
const stc7 = {
  "data-testid": "rollup-tile"
};
const stc8 = {
  classMap: {
    "skeleton-region": true
  },
  attrs: {
    "aria-hidden": "true"
  },
  key: 17
};
const stc9 = {
  classMap: {
    "section": true
  },
  key: 18
};
const stc10 = {
  classMap: {
    "card-grid": true
  },
  key: 21
};
const stc11 = {
  "skeleton-card": true
};
const stc12 = {
  "data-testid": "skeleton-card"
};
const stc13 = {
  "padding": "medium",
  "shadow": "elevation-2"
};
const stc14 = {
  classMap: {
    "list-rows": true
  },
  key: 27
};
const stc15 = {
  "item-row-wrap": true
};
const stc16 = {
  classMap: {
    "item-row": true
  },
  attrs: {
    "data-testid": "skeleton-row"
  },
  key: 29
};
const stc17 = {
  classMap: {
    "item-row-chevron": true
  },
  props: {
    "icon": "chevronright",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 36
};
const stc18 = {
  classMap: {
    "empty-search-state": true
  },
  attrs: {
    "data-testid": "empty-search-state"
  },
  key: 37
};
const stc19 = {
  classMap: {
    "content": true
  },
  attrs: {
    "data-testid": "content"
  },
  key: 41
};
const stc20 = {
  "section": true
};
const stc21 = {
  "data-testid": "section"
};
const stc22 = {
  classMap: {
    "card-grid": true
  },
  attrs: {
    "role": "list"
  },
  key: 45
};
const stc23 = {
  classMap: {
    "list-rows": true
  },
  attrs: {
    "role": "list"
  },
  key: 47
};
const stc24 = {
  "item-row": true
};
const stc25 = {
  "item-row-logo": true
};
const stc26 = {
  classMap: {
    "tag-list": true
  },
  key: 55
};
const stc27 = {
  classMap: {
    "item-row-chevron": true
  },
  props: {
    "icon": "chevronright",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 58
};
const stc28 = {
  classMap: {
    "item-row": true,
    "item-row--static": true
  },
  attrs: {
    "data-testid": "item-row"
  },
  key: 59
};
const stc29 = {
  classMap: {
    "tag-list": true
  },
  key: 65
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, c: api_custom_element, h: api_element, k: api_key, i: api_iterator, ncls: api_normalize_class_name, t: api_text} = $api;
  const {_m0, _m1, _m2, _m3, _m4} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.viewerTitle))]), $cmp.isLoading ? api_static_fragment($fragment2, 4, [api_static_part(1, null, api_dynamic_text($cmp.loadingLabel))]) : null, api_element("div", stc1, [api_custom_element("listing-search-input", _listingSearchInput, {
    classMap: stc2,
    props: {
      "placeholder": $cmp.searchPlaceholder,
      "value": $cmp.searchTerm,
      "disabled": $cmp.isLoading
    },
    key: 6,
    on: {
      "searchinput": _m0 || ($ctx._m0 = api_bind($cmp.handleSearchInput))
    }
  }), api_element("div", stc3, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc4,
    props: {
      "variant": "tertiary",
      "size": "small",
      "icon": $cmp.displayToggleIcon,
      "label": $cmp.displayToggleLabel
    },
    key: 8,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleDisplayToggleClick)),
      "analytics": _m2 || ($ctx._m2 = api_bind($cmp.handleDisplayToggleAnalytics))
    }
  })])]), $cmp.hasRollupTiles ? api_element("div", stc5, api_iterator($cmp.rollupTiles, function (tile) {
    return api_element("div", {
      classMap: stc6,
      attrs: stc7,
      key: api_key(10, tile.label)
    }, [api_static_fragment($fragment3, 12, [api_static_part(1, null, api_dynamic_text(tile.label))]), $cmp.isLoading ? api_static_fragment($fragment4, 14) : null, !$cmp.isLoading ? api_static_fragment($fragment5, 16, [api_static_part(1, null, api_dynamic_text(tile.count))]) : null]);
  })) : null, $cmp.isLoading ? api_element("div", stc8, [api_element("div", stc9, [$cmp.loadingSectionHeading ? api_static_fragment($fragment6, 20, [api_static_part(1, null, api_dynamic_text($cmp.loadingSectionHeading))]) : null, $cmp.isCardView ? api_element("div", stc10, api_iterator($cmp.cardSkeletons, function (card) {
    return api_custom_element("ax-card", _axCard, {
      classMap: stc11,
      attrs: stc12,
      props: stc13,
      key: api_key(22, card.id)
    }, [api_static_fragment($fragment7, 24), api_static_fragment($fragment8, 26)]);
  })) : null, $cmp.isListView ? api_element("div", stc14, api_iterator($cmp.rowSkeletons, function (row) {
    return api_element("div", {
      classMap: stc15,
      key: api_key(28, row.id)
    }, [api_element("div", stc16, [api_static_fragment($fragment9, 31), api_static_fragment($fragment10, 33), api_static_fragment($fragment11, 35), api_custom_element("ax-icon", _axIcon, stc17)])]);
  })) : null])]) : null, !$cmp.isLoading ? $cmp.showEmptySearchMessage ? api_element("div", stc18, [api_custom_element("wds-empty-state", _wdsEmptyState, {
    props: {
      "imgSrc": $cmp.emptySearchImageSrc,
      "imgHeight": "160px",
      "label": $cmp.emptySearchTitle,
      "labelTypeStyle": "display-7",
      "description": $cmp.emptySearchSubtitle
    },
    key: 38
  })]) : null : null, !$cmp.isLoading ? $cmp.showEmptyContentMessage ? api_static_fragment($fragment12, 40, [api_static_part(1, null, api_dynamic_text($cmp.emptySearchLabel))]) : null : null, !$cmp.isLoading ? $cmp.showContent ? api_element("div", stc19, api_iterator($cmp.filteredSections, function (section) {
    return api_element("div", {
      classMap: stc20,
      attrs: stc21,
      key: api_key(42, section.key)
    }, [api_static_fragment($fragment13, 44, [api_static_part(1, null, api_dynamic_text(section.heading))]), $cmp.isCardView ? api_element("div", stc22, api_iterator(section.items, function (item) {
      return api_custom_element("wds-listing-card", _wdsListingCard, {
        props: {
          "role": "listitem",
          "variant": "with-badge",
          "positionIndex": item.cardData.positionIndex,
          "listingCardData": item.cardData,
          "disableNavigation": item.disableNavigation
        },
        key: api_key(46, item.key),
        on: {
          "analytics": _m3 || ($ctx._m3 = api_bind($cmp.handleItemAnalytics))
        }
      });
    })) : null, $cmp.isListView ? api_element("div", stc23, api_iterator(section.items, function (item) {
      return api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
        classMap: stc15,
        props: {
          "type": "listingTile",
          "context": item.analyticsContext,
          "role": "listitem"
        },
        key: api_key(48, item.key),
        on: {
          "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleItemAnalytics))
        }
      }, [item.isNavigable ? api_element("a", {
        classMap: stc24,
        attrs: {
          "href": item.url,
          "data-testid": "item-row"
        },
        key: 49
      }, [api_custom_element("ax-image", _axImage, {
        classMap: stc25,
        props: {
          "height": "44px",
          "width": "44px",
          "imgSrc": item.logoUrl,
          "alt": item.title
        },
        key: 50
      }), api_static_fragment($fragment14, 52, [api_static_part(2, null, api_dynamic_text(item.title)), api_static_part(4, null, api_dynamic_text(item.listSubtitle))]), api_element("span", {
        className: api_normalize_class_name(item.typePillClass),
        key: 53
      }, [item.hasTypeIcon ? api_custom_element("ax-icon", _axIcon, {
        props: {
          "icon": item.typeIcon,
          "size": "xsmall",
          "ariaHidden": "true"
        },
        key: 54
      }) : null, api_text(api_dynamic_text(item.typeLabel))]), item.hasCategories ? api_element("div", stc26, api_iterator(item.categories, function (category) {
        return api_static_fragment($fragment15, api_key(57, category), [api_static_part(1, null, api_dynamic_text(category))]);
      })) : null, api_custom_element("ax-icon", _axIcon, stc27)]) : null, !item.isNavigable ? api_element("div", stc28, [api_custom_element("ax-image", _axImage, {
        classMap: stc25,
        props: {
          "height": "44px",
          "width": "44px",
          "imgSrc": item.logoUrl,
          "alt": item.title
        },
        key: 60
      }), api_static_fragment($fragment16, 62, [api_static_part(2, null, api_dynamic_text(item.title)), api_static_part(4, null, api_dynamic_text(item.listSubtitle))]), api_element("span", {
        className: api_normalize_class_name(item.typePillClass),
        key: 63
      }, [item.hasTypeIcon ? api_custom_element("ax-icon", _axIcon, {
        props: {
          "icon": item.typeIcon,
          "size": "xsmall",
          "ariaHidden": "true"
        },
        key: 64
      }) : null, api_text(api_dynamic_text(item.typeLabel))]), item.hasCategories ? api_element("div", stc29, api_iterator(item.categories, function (category) {
        return api_static_fragment($fragment17, api_key(67, category), [api_static_part(1, null, api_dynamic_text(category))]);
      })) : null]) : null]);
    })) : null]);
  })) : null : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1gpcbs77nmm";
tmpl.legacyStylesheetToken = "undefined-_packageContentsViewer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
